/**
 * 导入校企合作人员信息 2022-12-04
 * createBy : pengwen
 */
 import React from 'react';
 import { connect } from 'dva';
 
 import { component_tool,utils_tool, framework_tool } from '@/tool'
 let { WizTypography,WizButton, WizSpin,WizTreeSelect,WizModal } = component_tool;
 let { WizContainer } = framework_tool;
 const { Paragraph } = WizTypography;
 import { ExportExcel } from '@/components/index'
 import {modelUtils} from '@/utils';
 let {Session} = utils_tool;
 
 
 
 class ImportSchoolCooperationPerson extends WizContainer {
 
   componentName = 'personManage';
 
   constructor(props) {
     super(props);
     this.state = {
     }
   }
 
   _componentDidMount() {
 }
 
   _handldImport(nextProps, nextState) {
       log.info(`nextProps`,nextProps)
     let o = nextProps['importSchoolCooperationPerson']
     if (o['success']) {
       let data = o['data'];
       let str = data.replace(/<br\/>/g,"\n")
       WizModal.success({
 
         title:'导入成功',
 
         content: <p style={{whiteSpace: "pre-line"}}>{str}</p>,
       })
       return true;
     } else {
       let data = o['msg'];
       let str = data.replace(/<br\/>/g,"\r\n")
 
       WizModal.error({
 
         title:'导入失败',
 
         content: <p style={{whiteSpace: "pre-line"}}>{str}</p>,
       })
      // wizNotice.error(str||"导入数据出错，请联系相关人员")
       return true;
     }
   }
 
   propsAndStateOnChange = {
    importSchoolCooperationPerson: this._handldImport.bind(this),
   }
 
 
   _render() {
     const{type} = this.state
     let infoProps = {
       title: '导入说明',
       text: [
         <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
         <Paragraph>2、按照要求格式填写信息</Paragraph>,
         <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
       ]
     }
     let operateProps = {
       title: '导入校企合作人员',
       template: {
         label: '模版下载',
         fileName: '导入校企合作人员模版.xlsx',
         href: constants.files.excel_importSchoolCooperationPerson,
       }
 
     }
     let submit  = (file, fileData, other) => {
         const{categoryId} = other
       let apiPath = 'personManage/importSchoolCooperationPerson';
       this.doAction({
         path: apiPath,
         payload: {
           key: "importSchoolCooperationPerson",
           apiParams: {
             fileData,
           }
         }
       });
     }
 
     let { personManageLoading } = this.props;
     return (

       <WizSpin tip={'文件上传中'} spinning={personManageLoading}>
         <ExportExcel
           infoProps={infoProps}
           operateProps={operateProps}
           submit={submit}
           //other={other}
         />
       </WizSpin>
     );
   }
 }
 
 const mapStateToProps = (state, ownProps) => {
   const { personManage } = state;
   const importSchoolCooperationPerson = modelUtils.getModelEntity(personManage, 'importSchoolCooperationPerson');
 
 
   //获取loading的方式
   const load = modelUtils.getLoadingState(state,[ 'personManage'])
   return {
    importSchoolCooperationPerson,
     ...load
   }
 };
 
 export default connect(mapStateToProps)(ImportSchoolCooperationPerson);
 